const Style = {

  wrapper:  'relative inline-block',
  trigger:  'bg-transparent border-none cursor-pointer text-gray-700 text-xl leading-none px-1.5 py-0.5 rounded hover:bg-gray-100',
  dropdown: 'absolute right-0 top-full z-[100] bg-white border border-gray-200 rounded-lg shadow-md min-w-[140px]',
  item:     'block w-full px-4 py-2 text-left text-sm bg-transparent border-none cursor-pointer hover:bg-gray-50',

}

export default Style;
